import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { VRSTA_OPERATERA, VRSTA_ZAHTJEVA } from "../../../../enums";
import { useFormContext } from "react-hook-form";
import dayjs from "dayjs";
import { useState } from "react";

const Index = ({ trenutniDatum }: any) => {
  const { register, getValues, watch } = useFormContext();
  const watchTrenutniDatumVZ = trenutniDatum;
  const trenutniDatumVZ = trenutniDatum;
  const vrstaZahtjeva = watch("vrstaZahtjeva");
  const vrstaOperatera = parseInt(
    getValues("operaterPlatforme.vrstaOperatera.id")
  );

  if (VRSTA_OPERATERA.IZVAN_EU === vrstaOperatera) return null;

  return (
    <Box sx={{ ml: 3 }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        value={vrstaZahtjeva}
        name="radio-buttons-group"
      >
        {(dayjs(trenutniDatumVZ).isBetween(
          "2023-11-01",
          dayjs("2023-12-31"),
          "day",
          "[]"
        ) ||
          dayjs(trenutniDatumVZ).isAfter("2024-01-31")) && (
          <FormControlLabel
            value={VRSTA_ZAHTJEVA.ISKLJUCENJE}
            control={<Radio {...register("vrstaZahtjeva")} />}
            label="Zahtjev za isključenog operatera platforme (Request for Excluded Platform Operator)"
          />
        )}
        {(dayjs(trenutniDatumVZ).isBetween(
          "2024-01-01",
          dayjs("2024-01-31"),
          "day",
          "[]"
        ) ||
          dayjs(trenutniDatumVZ).isAfter("2024-01-31")) && (
          <FormControlLabel
            value={VRSTA_ZAHTJEVA.REGISTRACIJA}
            control={<Radio {...register("vrstaZahtjeva")} />}
            label="Zahtjev za registraciju (Registration request)"
          />
        )}
      </RadioGroup>
    </Box>
  );
};
export default Index;
